<template>
    <div id="mentions-container">
        <v-progress-circular v-if="uploadingAsset" class="my-auto ml-1 mt-2" indeterminate color="var(--primary)" size="20" width="3"></v-progress-circular>

        <div v-for="(mention, index) in mentionedAssets" :key="`${mention.id}-${index}`" class="asset-container mt-2">
            <component @click.native="onThumbnailClick($event, mention)" :is="thumbnailComponent" :item="assetById(mention.id, mention.fileType)" />
            <span @click.stop="removeAsset(mention)" class="btn-remove-asset material-icons">cancel</span>
        </div>
    </div>
</template>

<script>
import Thumbnail from '@/components/app/projects/Thumbnail';

import { mapGetters, mapState } from 'vuex';
import AvatarMixin from "@/mixins/Avatar";
import FilenameMixin from "@/mixins/Filename";

export default {
    name: "MentionedAssets",
    mixins: [AvatarMixin, FilenameMixin],
    computed: {
        ...mapState('Comments', ["mentionedAssets", "uploadingAsset"]),
        ...mapGetters('Comments', ["assetMentionsFromDelta"]),
        ...mapState('User', ["user"]),
        ...mapState('Projects', ["bin"]),
        ...mapGetters('Projects', ["assetById", "fileHasTag"]),
        thumbnailComponent() {
            return Thumbnail;
        },
    },
    methods: {
        async onThumbnailClick(e, mention) {
            let file = this.assetById(mention.id, mention.fileType);

            if (this.fileHasTag(file, 'comment_upload', 1)) {
                this.$root.ViewCommentUploadModal.username = this.user.name
                this.$root.ViewCommentUploadModal.avatar = this.getGravatar(this.user.email);
                this.$root.ViewCommentUploadModal.filename = this.stripTimestamp(file.name);
                this.$root.ViewCommentUploadModal.created_at = 'just now';
                this.$root.ViewCommentUploadModal.image = file;
                this.$root.ViewCommentUploadModal.imagesList = this.mentionedAssets.map(mention => this.assetById(mention.id, mention.fileType));

                UI.showModal(UI.modals.viewCommentUpload.el);
            } else {
                this.$root.projectTree.onFileSelection(e, this.bin.id, file);
            }
        },

        removeAsset(mention) {
            this.$root.commentsEditor.removingMentionedAsset = true;
            let delta = this.$root.commentsEditor.quill.getContents();

            let newDelta = {
                ops: []
            };

            delta.ops.forEach((item, key) => {
                if (item?.insert?.mention &&
                    item.insert.mention.denotationChar == mention.denotationChar &&
                    item.insert.mention.id == mention.id) {
                    return;
                }

                newDelta.ops.push(item);
            })

            this.$root.commentsEditor.quill.setContents(newDelta);
            this.$store.dispatch("Comments/setMentionedAssets", this.assetMentionsFromDelta(newDelta));

            if (newDelta.ops.length == 1 && newDelta.ops[0].insert.trim() == '') {
                this.$root.commentsEditor.quill.setContents([]);
            }

            this.$root.commentsEditor.removingMentionedAsset = false;
        }
    }
}
</script>

<style lang="scss" scoped>
#mentions-container {
    grid-column: 1/3;
    display: grid;
    grid-template-columns: repeat(5, minmax(auto, 20%));
    grid-column-gap: 15px;
    grid-row-gap: 8px;
    padding: 0 8px;

    img {
        aspect-ratio: 1;
        width: 100%;
        object-fit: cover;
        object-position: center;
        cursor: pointer;
    }

    ::v-deep .placeholder-preview {
        height: 33px;
    }

    .asset-container {
        position: relative;
    }

    .btn-remove-asset {
        font-size: 16px;
        color: white;
        background: #121212;
        border-radius: 25px;
        position: absolute;
        border: 1px solid #121212;
        top: 0;
        right: 0;
        transform: translate(50%, -50%);
        cursor: pointer;
    }
}
</style>